import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
// apis
import { acknowledgeExpiredNotification, getExpiredNotification } from 'api';
// components
import { AgreementExpiredMessage } from './AgreementExpiredMessage';
// styles
import styles from './AgreementsAlertsList.module.css';

const AgreementAlertsStack = () => {
    const {
        pathname,
        query: { posId },
    } = useRouter();
    const [visibleAlerts, setVisibleAlerts] = useState<any>([]);
    const [idDeleted, setIdDeleted] = useState<any>([]);
    const [emptyAlerts, setEmptyAlerts] = useState<boolean>(true);

    useEffect(() => {
        if (['/[clientId]/efficient-purchase/[posId]'].includes(pathname)) {
            getExpiredNotification()
                .then((response) => {
                    // dejamos solo los que tengan drug_manufacturers vencidas
                    const filteredAlerts = response.data.data.filter(
                        (item: any) => item.drug_manufacturers && item.drug_manufacturers.length > 0,
                    );

                    if (filteredAlerts.length > 0) {
                        setEmptyAlerts(false);
                    }

                    setVisibleAlerts(filteredAlerts);
                })
                .catch((e) => console.error(e));
        }
    }, [posId]);

    const handleRemoveAlert = async (notification_type_id) => {
        await acknowledgeExpiredNotification({ notification_type_id });
        setIdDeleted((prevState) => [...prevState, notification_type_id]);
    };

    return (
        <div className={`${styles['wrapper']} ${emptyAlerts ? styles['hidden'] : ''}`}>
            {visibleAlerts.map((agreement: any, index: number) => {
                return (
                    <AgreementExpiredMessage
                        key={agreement.notification_type_id}
                        handleRemoveAlert={() => handleRemoveAlert(agreement.notification_type_id)}
                        agreement={agreement}
                        setVisibleAlerts={setVisibleAlerts}
                        idDeleted={idDeleted}
                    />
                );
            })}
        </div>
    );
};

export default AgreementAlertsStack;
